const checkboxes = document.querySelectorAll('.checkbox');

checkboxes.forEach((checkbox) => {
  const checkboxBtn = checkbox.querySelector('.checkbox__modal-open');
  const checkboxId = checkbox.querySelector('input').id;

  if (checkboxBtn) {
    const checkboxModal = document.querySelector(`.checkbox__modal-wrapper.${checkboxId}`);
    const checkboxClose = checkboxModal.querySelector('.checkbox__modal-close');

    checkboxBtn.addEventListener('click', () => {
      checkboxModal.classList.add('is-open');
    });

    checkboxClose.addEventListener('click', () => {
      checkboxModal.classList.remove('is-open');
    });
  }
});
